/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ user: NonNullable<unknown>, program: NonNullable<unknown> }} Recent_Payment_ProgramInputs */

const fr_recent_payment_program = /** @type {(inputs: Recent_Payment_ProgramInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.user} a payé pour le programme ${i?.program}`)
};

/**

* @param {Recent_Payment_ProgramInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const recent_payment_program = /** @type {((inputs: Recent_Payment_ProgramInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recent_Payment_ProgramInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_recent_payment_program(inputs)
});